<template>
    <a-form
        layout="horizontal"
    >   
        
        <a-form-item
            v-bind="formItemLayout"
        >
            <h3
                slot="label"
            >
                {{ label }}
            </h3>
            <a-slider
                :max="max"
                :min="min"
                :range="interval ? true : false"
                :value="selectedRangeInner"
                v-on:change="rangeChange"
                :marks="marks"
            >
            </a-slider>
            <a-row
                type="flex"
                justify="space-around"
                align="middle"
            >
                <template
                    v-if="interval"
                >
                    <a-col
                        :span="12"
                        align="center"
                    >
                        <a-input-number 
                            :min="min"
                            :max="max"
                            v-model="selectedRangeInner[0]"
                        />
                    </a-col>
                    <a-col 
                        :span="12"
                        align="center"
                    >
                        <a-input-number 
                            :min="min"
                            :max="max"
                            v-model="selectedRangeInner[1]"
                        />
                    </a-col>
                </template>
                <template
                    v-else
                >
                    <a-col 
                        :span="24"
                        align="center"
                    >
                        <a-input-number 
                            :min="min"
                            :max="max"
                            v-model="selectedRangeInner"
                        />
                    </a-col>
                </template>
            </a-row>
        </a-form-item>
    </a-form>
</template>

<script>
export default {
    name: 'SearchSlider',
    props: {
        interval: {
            type: Boolean,
            default: false
        },
        label: String,
        selectedRange: {
            type: Array | Number,
            default: 1
        },
        max: Number,
        min: Number
    },
    model: {
        prop: 'selectedRange',
        event: 'rangeChange'
    },

    data() {
        return {
            formItemLayout: {
                labelCol: { span: 24 },
                wrapperCol: { span: 24 }
            }
        }
    },

    computed: {
        marks() {
            const marks = {};
            for (let i = this.min; i <= this.max; i ++) {
                marks[i] = i;
            }
            return marks;
        },
        selectedRangeInner: {
            get() {
                return this.selectedRange;
            },
            set(val) {
                this.rangeChange(val);
            }
        }
    },

    methods: {
        rangeChange(val) {
            this.$emit('rangeChange', val)
        }
    }
}
</script>

<style lang="scss" scoped>

</style>